export default (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M18.75 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5ZM5.25 2.25C3.59315 2.25 2.25 3.59315 2.25 5.25V18.75C2.25 20.4069 3.59315 21.75 5.25 21.75H18.75C20.4069 21.75 21.75 20.4069 21.75 18.75V5.25C21.75 3.59315 20.4069 2.25 18.75 2.25H5.25Z"
    fill="currentColor"
  />
);
